// @flow
import * as React from 'react';
import styled, { withTheme } from 'styled-components';
import { translate } from 'react-i18next';
import PrintingCard from 'common/modules/printing/styles/PrintingCard';
import SingleMetric from '../../metrics/components/SingleMetric';

const SCard = styled(PrintingCard)`
  margin-top: ${({ theme }) => theme.metrics.smallMargin}px;
`;

const StyledMetric = styled(SingleMetric)`
  padding: ${({ theme }) => theme.metrics.smallMargin}px 0px;
`;

type Props = {
  cumulativeMetrics: {
    reach: number,
    listeningTime: number,
    listeningTimePerPerson: number,
  },
  averageMetrics: {
    reach: number,
    listeningTime: number,
    listeningTimePerPerson: number,
  },
  t: any,
}

function DashboardPrintingMonthlyMetricsCard({ cumulativeMetrics, averageMetrics, t }: Props) {
  return (
    <SCard>
      <StyledMetric title={t('cumulativeReach')} value={cumulativeMetrics.reach} />
      <StyledMetric title={`${t('cumulativeListeningTime')} (${t('hours')})`} value={cumulativeMetrics.listeningTime} />
      {cumulativeMetrics.listeningTimePerPerson &&
      <StyledMetric title={`${t('cumulativeListeningTimePerPerson')} (${t('hours')})`}
        value={cumulativeMetrics.listeningTimePerPerson} roundAt={2}
      />
      }
      <StyledMetric title={t('weeklyReach')} value={averageMetrics.reach} />
      <StyledMetric title={`${t('weeklyListeningTime')} (${t('hours')})`} value={averageMetrics.listeningTime} />
      {averageMetrics.listeningTimePerPerson &&
      <StyledMetric title={`${t('weeklyListeningTimePerPerson')} (${t('hours')})`}
        value={averageMetrics.listeningTimePerPerson} roundAt={2}
      />
      }
    </SCard>
  );
}

export default withTheme(translate('dashboard')(DashboardPrintingMonthlyMetricsCard));



// WEBPACK FOOTER //
// ./src/statsradio/modules/dashboard/printing/DashboardPrintingMonthlyMetricsCard.js